<template>
  <div class="bg">
    <section class="section section-lg pt-lg-0 section-contact-us">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 mt-5">
            <card shadow body-classes="p-lg-5 text-default" type="secondary">
              <h4 class="mb-1">Your Future is Worth a Phone Call.</h4>
              <p class="mt-0">Contact us today to schedule a free consultation by filling out the form below, or by calling our toll-free number below.</p>
              <p class="phone m-3">
                <i class="fa fa-phone"></i>  800-431-8509<br />
                <i class="fa fa-home"></i>  100 Cherokee Blvd. Suite 301, Chattanooga, TN. 37405
              </p>
              <div class="error-message">
                <p v-show="!form.emailValid">Oh, please enter a valid email address. </p>
              </div>
              <form 
                method="post"
                action="/success"
                netlify 
                netlify-honeypot="bot-field"
              >
                <input type="hidden" name="form-name" :value="form.name" />
                <input type="hidden" name="bot-field" />
                <base-input 
                  v-model="form.content.name" 
                  name="name" 
                  type="text" 
                  @focus="$event.target.select()" 
                  required
                  addon-left-icon="ni ni-user-run" 
                  class="mt-5 text-dark"
                >
                </base-input>
                <base-input 
                  v-model="form.content.email" 
                  name="email" 
                  type="email"  
                  @focus="$event.target.select()" 
                  required 
                  addon-left-icon="ni ni-email-83"
                  :class="{ error: !form.emailValid }"
                >
                </base-input>
                <base-input 
                  v-model="form.content.phone" 
                  name="phone" 
                  type="tel"  
                  @focus="$event.target.select()" 
                  required 
                  addon-left-icon="ni ni-mobile-button"
                >
                </base-input>
                <base-input class="mb-4">
                  <textarea 
                    v-model="form.content.message" 
                    name="message"
                    @focus="$event.target.select()" 
                    required 
                    placeholder="Type a message..." 
                    rows="4" 
                    cols="80" 
                    class="form-control form-control-alternative"
                  >
                  </textarea>
                </base-input>
                <base-button type="default" size="lg" nativeType="submit" text="Send Message" block >
                  Send Message
                </base-button>
              </form>
            </card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// eslint-disable-next-line
const emailRegExp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export default {
  name: 'Contact',
  data: function() {
    return {
      form: {
        name: 'forward-form',
        emailValid: true,
        content: {
          name: 'Your Name',
          email: 'your@email.com',
          phone: '123-456-7890',
          message: 'Dear Forward Financial...'
        }
      }
    };
  },
  methods: {
    // validate by type and value
    validate: function(type, value) {
      if (type === "email") {
        this.form.emailValid = this.isEmail(value) ? true : false;
      }
    },
    // check for valid email adress
    isEmail: function(value) {
      return emailRegExp.test(value);
    }
  },
  watch: {
    // watching nested property
    "form.content.email": function(value) {
      this.validate("email", value);
    }
  }
}
</script>

<style>
.phone {
  font-size: 1em;
}
</style>
